export const ToggleList = {
  UserGroups: "user-groups",
  AccessRequest: "access-request",
  LastImported: "last-import",
  InformationAssets: "information-assets",
  ReviewCycle: "review-cycle",
  UserGuide: "user-guide",
  SaveAsDraft: "save-as-draft",
  ExportMyTasks: "export-my-tasks",
  ReviewInFullScreen: "review-in-full-screen",
  GuidedTourForReview: "guided-tour-for-review",
  BatchDelegation: "batch-delegation",
  AccessVisibilityForSisenseDatasource : "access-visibility-for-sisense-datasource",
  UserGroupPageRevamp :"business-teams-page-revamp",
  PoliciesUi : "policies-ui",
  IndividualInclusionNaming : "individual-inclusion-naming"
};
